<template>
  <div class="cart-summary">
    <h3 class="cart-summary__title">
      Total
    </h3>

    <dl class="cart-summary__totals">
      <template v-if="cart.subTotal">
        <dt>Subtotal</dt>
        <dd>{{ cart.subTotal }}</dd>
      </template>

      <template v-if="cart.shipping">
        <dt>Shipping</dt>
        <dd>{{ cart.shipping }}</dd>
      </template>

      <template v-if="cart.discount">
        <dt>Discount</dt>
        <dd>
          <div class="cart-summary__discount">
            <span v-if="cart.discountCode">({{ cart.discountCode }})</span>
            <button class="close-button" @click="removeDiscount"></button>
          </div>
          {{ cart.discount }}
        </dd>
      </template>

      <template v-if="cart.total">
        <dt>Total</dt>
        <dd>{{ cart.total }}</dd>
      </template>
    </dl>

    <form class="cart-summary__discount-form" @submit.prevent="addDiscount" v-if="!cart.discountCode">
      <label class="cart-summary__form-label">
        Apply a discount code to basket total
      </label>

      <div class="cart-summary__discount-form-row">
        <input type="text"
                name="discountCode"
                v-model="discountCode"
                required />

        <button type="submit"
                class="button"
                :class="{ 'button--disabled': !discountCode }"
                :disabled="!discountCode">
          Apply
        </button>
      </div>
    </form>

    <button class="button button--primary cart-summary__button"
            :class="{ 'button--disabled': !isValid }"
            :disabled="!isValid"
            @click="submit">
      Checkout
    </button>
  </div>
</template>

<script>
import cartStore from '../../../vue-apps/stores/cart';

export default {
  data() {
    return {
      discountCode: null,
      hasUnfilledSheets: false
    };
  },
  props: {
    cart: {
      type: Object,
      required: true
    },
    submitUrl: {
      type: String
    }
  },
  computed: {
    isValid() {
      return this.cart.items.length > 0 && !this.hasUnfilledSheets;
    }
  },
  watch: {
    cart: {
      handler() {
        this.checkForUnfilledSheets();
      },
      deep: true
    }
  },
  methods: {
    addDiscount(event) {
      const form = event.target;
      cartStore.addDiscount(this.discountCode).then(res => {
        form.reset();
      })
      .catch(err => {
        this.cart.loading = false;
        form.discountCode.setCustomValidity('Invalid discount code');
        form.discountCode.reportValidity();
      });
    },
    removeDiscount() {
      cartStore.removeDiscount(this.cart.discountCode).then(res => {
        this.discountCode = null;
      })
      .catch(err => {
        this.cart.loading = false;
      });
    },
    submit() {
      window.location.href = this.submitUrl;
    },
    checkForUnfilledSheets() {
      this.hasUnfilledSheets = this.cart.items.some((item) => {
        const { isSheet, maxItems } = item.metaData;

        const totalQuantity = item.designs.reduce((quantity, design) => {
          return quantity + design.quantity;
        }, 0);

        return isSheet && totalQuantity !== maxItems;
      });
    }
  },
  mounted() {
    this.checkForUnfilledSheets();
  }
};
</script>